import React, { useContext, useEffect, useRef, useState } from 'react';
import './style.scss';
import GradientSpinnerIcon from 'src/assets/icons/GradientSpinner';
import DownChevron from 'src/assets/icons/DownChevron';
import { useCommonContext } from 'src/contexts/CommonContext';
import { database } from 'src/utils/firebase';
import { onValue, ref } from 'firebase/database';
import { useHistory } from 'react-router-dom';
import { 
  Popover, 
  Paper, 
  Box
} from '@mui/material';
import blueArrow from 'src/assets/images/common/right-blue-arrow.svg';
import { FloatingAlert } from 'src/views/notification/components/floating-alert';
import useApi from 'src/hooks/useApi';
import services from 'src/api/service';
import indexedDBManager from 'src/utils/indexedDB';
import { getDspDetails } from 'src/views/pages/utils';
const ProcessNotification = () => {
  const { commonState, commonDispatch } = useCommonContext();
  const history = useHistory();
  const [currentCount, setCurrentCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [isProcessing, setIsProcessing] = useState(false);
  const [showPopover, setShowPopover] = useState(false);
  const [selectedJobId, setSelectedJobId] = useState(null);
  const [allJobsData, setAllJobsData] = useState({});
  const [completedJobs, setCompletedJobs] = useState([]);
  const [completedJobIds, setCompletedJobIds] = useState([]);
  const [showJobCompletionAlert, setShowJobCompletionAlert] = useState(false);
  const [bulkJobs, setBulkJobs] = useState([]);
  const [alertTimeoutId, setAlertTimeoutId] = useState(null);
  const fetchJobs = useApi(services.getService);
  
  const firebaseDataRef = useRef({});
  const firebaseConnectionRef = useRef(null);
  const dropdownRef = useRef(null);

  const getProfile = JSON.parse(sessionStorage.getItem('selectedProfileId'));
  const masterFilter = JSON.parse(sessionStorage.getItem('master-account-filters')) || {}
  const dspDetails = getProfile?.dsp ? getDspDetails(getProfile, masterFilter) :{};

  const jobIds = (() => {
    if (Array.isArray(commonState.jobId)) return commonState.jobId;
    try {
      const stored = localStorage.getItem('Processing-Job-ID');
      if (!stored) return [];
      const parsed = JSON.parse(stored);
      return Array.isArray(parsed) ? parsed : [parsed];
    } catch {
      const stored = localStorage.getItem('Processing-Job-ID');
      return stored ? [stored] : [];
    }
  })();
  
  const jobId = selectedJobId || (Array.isArray(jobIds) && jobIds.length > 0 ? jobIds[jobIds.length - 1] : null);
  const amazonDsp = window.location.href.indexOf('amazon-dsp') > -1 
  const isAmazonTargeting = window.location.href.indexOf('amazon/targeting') > -1
  useEffect(() => {
    if(amazonDsp || !isAmazonTargeting) return;
    fetchJobs.request({
      url: '/amazon/bulk-jobs/list',
      nodeAPI: 1,
      payload: {}
    });
  }, [jobIds]);
  
  useEffect(() => {
    const {data, loading} = fetchJobs;
    if (data?.success && !loading && data?.data?.jobs?.length > 0) {
      setBulkJobs(data?.data?.jobs);
    }
  }, [fetchJobs?.loading]);
  
  useEffect(() => {
    if (jobIds.length > 0 && !selectedJobId) {
      setSelectedJobId(jobIds[jobIds.length - 1]);
    }
    
    if (selectedJobId && jobIds.length > 0 && !jobIds.includes(selectedJobId)) {
      setSelectedJobId(jobIds[jobIds.length - 1]);
    }
    
    if (jobIds.length === 0 && selectedJobId) {
      setSelectedJobId(null);
    }
  }, [jobIds, selectedJobId]);


  const setupFirebaseListener = (targetJobId) => {
    if (!targetJobId) return null;
        
    try {
      const jobRef = ref(database, `/1288029722961222/JOBS/${targetJobId}`);
      return onValue(
        jobRef, 
        async (snapshot) => {
          try {
            const data = snapshot.val();
            console.log('Firebase data received for job:', targetJobId, data);
            
            if (snapshot.exists() && data) {
              const percentage = data.percentage || 0;
              
              setAllJobsData(prev => ({
                ...prev,
                [targetJobId]: {
                  currentCount: data.updatedCount || 0,
                  totalCount: data.totalCount || 0,
                  percentage: percentage,
                  isCompleted: percentage === 100
                }
              }));
              
              if (targetJobId === jobId) {
                const firebaseCurrentCount = data.updatedCount || 0;
                const firebaseTotalCount = data.totalCount || 0;
                
                setCurrentCount(firebaseCurrentCount);
                setTotalCount(firebaseTotalCount);
                setIsProcessing(percentage < 100);
              }
              
              if (percentage === 100) {
                
                if (commonState.sweetAlertActionTriggered) {
                  setCompletedJobIds(prev => [...prev, targetJobId]);
                  
                  const completedJob = {
                    jobId: targetJobId,
                    cpcType: bulkJobs[targetJobId]?.cpcType?.replace(/_/g, ' ') || bulkJobs[0]?.cpcType?.replace(/_/g, ' '),
                  };
                  
                  indexedDBManager.addCompletedJob(completedJob)
                    .then(() => {
                      console.log('Completed job stored in IndexedDB:', completedJob);
                    })
                    .catch((error) => {
                      console.error('Error storing completed job in IndexedDB:', error);
                    });
                  
                  const timeoutId = setTimeout(() => {
                    setCompletedJobs(prev => [...prev, completedJob]);
                    setShowJobCompletionAlert(true);
                  }, 5000);
                  
                  setAlertTimeoutId(timeoutId);
                  
                  commonDispatch({ type: 'SET_SWEET_ALERT_ACTION_TRIGGERED', payload: false });
                }
                
                setTimeout(() => {
                  commonDispatch({
                    type: 'REMOVE_JOB_ID',
                    payload: targetJobId
                  });
                }, 2000);
              }
            } else {
              console.log('No data found at Firebase path for job:', targetJobId);
              if (targetJobId === jobId) {
                setIsProcessing(false);
              }
            }
          } catch (error) {
            console.error('Error processing Firebase data for job:', targetJobId, error);
            if (targetJobId === jobId) {
              setIsProcessing(false);
            }
          }
        },
        (error) => {
          console.error('Firebase connection error for job:', targetJobId, error);
          if (targetJobId === jobId) {
            setIsProcessing(false);
          }
        }
      );
    } catch (error) {
      console.error('Error setting up Firebase listener for job:', targetJobId, error);
      return null;
    }
  };

  useEffect(() => {
    const unsubscribes = [];
    
    jobIds.forEach(jobId => {
      const unsubscribe = setupFirebaseListener(jobId);
      if (unsubscribe) {
        unsubscribes.push(unsubscribe);
      }
    });

    return () => {
      unsubscribes.forEach(unsubscribe => {
        if (unsubscribe) unsubscribe();
      });
    };
  }, [jobIds]);

  useEffect(() => {
    if (selectedJobId && allJobsData[selectedJobId]) {
      const jobData = allJobsData[selectedJobId];
      setCurrentCount(jobData.currentCount);
      setTotalCount(jobData.totalCount);
      setIsProcessing(!jobData.isCompleted);
    }
  }, [selectedJobId, allJobsData]);

  const handleJobSelect = (jobId) => {
    setSelectedJobId(jobId);
    setShowPopover(false);
    history.push(`/amazon/cpc-job-listing/${jobId}`);
  };

  const handleJobCompletionAlertClose = () => {
    setShowJobCompletionAlert(false);
    setCompletedJobs([]);
    
    if (alertTimeoutId) {
      clearTimeout(alertTimeoutId);
      setAlertTimeoutId(null);
    }
  };

  // Cleanup timeout on component unmount
  useEffect(() => {
    return () => {
      if (alertTimeoutId) {
        clearTimeout(alertTimeoutId);
      }
    };
  }, [alertTimeoutId]);

  return (
    <>
      <div className="process-notification cursor-pointer" ref={dropdownRef} onClick={() => setShowPopover(jobIds.length > 1 ? !showPopover : false)}
        style={{
          display: jobIds.length === 0 || !jobId || commonState.doBulkUpdateData !== 1 ? 'none' : 'inline-block',
        }}  
      >
        <div className="process-notification-content">
          {/* <div className="process-notification-text">
            <span>{message}</span>
          </div> */}
          <div className='d-flex align-items-center gap-10'>
              <div className="process-notification-text">
                <span className="progress-text">{jobId}</span>
                {bulkJobs?.find(job => job.jobId === jobId) && <span className="progress-secondary-text">({bulkJobs?.find(job => job.jobId === jobId)?.cpcType?.replace(/_/g, ' ')})</span>}
              </div>
              <div className='d-flex'><GradientSpinnerIcon /></div>
              
              <div className="process-notification-count">
                {currentCount}/{totalCount}
              </div>
              
              {jobIds.length > 1 && (
                <div className="job-dropdown-container">
                  <DownChevron className="dropdown-down-chevron" data-active={Boolean(showPopover)} width={10} height={10} />
                  
                  <Popover
                    open={showPopover}
                    anchorEl={dropdownRef.current}
                    onClose={() => setShowPopover(false)}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'left',
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'left',
                    }}
                    className="job-progress-popover"
                  >
                    <Paper sx={{ width: 460, p: 1.5 }}>
                      <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                        {jobIds.map((id, index) => {
                          const jobData = allJobsData[id] || {};
                          const isSelected = id === selectedJobId;
                          return (
                            <li
                              key={id}
                              onClick={() => handleJobSelect(id)}
                              style={{
                                cursor: 'pointer',
                                borderRadius: '4px',
                                marginBottom: index === jobIds.length - 1 ? '0' : '4px',
                                display: 'flex',
                                alignItems: 'center',
                                backgroundColor: 'white',
                                padding: '10px 8px',
                                transition: 'all 0.2s ease',
                                position: 'relative',
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = '#1877f217';
                                const rightArrow = e.currentTarget.querySelector('.right-arrow');
                                if (rightArrow) {
                                  rightArrow.style.display = 'block';
                                  rightArrow.style.opacity = '1';
                                  rightArrow.style.transform = 'translateX(0)';
                                }
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = 'white';
                                const rightArrow = e.currentTarget.querySelector('.right-arrow');
                                if (rightArrow) {
                                  rightArrow.style.display = 'none';
                                  rightArrow.style.opacity = '0';
                                  rightArrow.style.transform = 'translateX(-8px)';
                                }
                              }}
                            >
                              <div style={{ flex: 1 }}>
                                <span style={{ fontWeight: 600, color: '#1777f2', fontSize: '12px' }}>
                                  {id}
                                </span>
                                {bulkJobs?.find(job => job.jobId === id) && <span className="progress-secondary-text f-11 ml-1">({bulkJobs?.find(job => job.jobId === id)?.cpcType?.replace(/_/g, ' ')})</span>}
                              </div>
                              <div style={{ minWidth: 'auto', marginLeft: '8px', display: 'flex', alignItems: 'center' }}>
                                {jobData.isCompleted ? (
                                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" fill="#4caf50"/>
                                  </svg>
                                ) : (
                                  <div style={{ width: 16, height: 16 }}>
                                    <GradientSpinnerIcon />
                                  </div>
                                )}
                              </div>
                              <div style={{ paddingLeft: '8px' }}>
                                <span style={{ fontWeight: 600, color: '#1777f2', fontSize: '12px' }}>
                                  {jobData.currentCount || 0}/{jobData.totalCount || 0}
                                  {jobData.percentage && (
                                    <span style={{ color: '#1A77F2', fontWeight: 500, marginLeft: '4px' }}>
                                      ({jobData.percentage}%)
                                    </span>
                                  )}
                                </span>
                              </div>
                              {/* Right arrow that appears on hover */}
                              <div 
                                className="right-arrow"
                                style={{
                                  marginLeft: '12px',
                                  opacity: '0',
                                  transform: 'translateX(-8px)',
                                  transition: 'all 0.2s ease',
                                  display: 'none',
                                  alignItems: 'center',
                                }}
                              >
                                <img 
                                  src={blueArrow} 
                                  alt="Right arrow" 
                                  style={{ 
                                    width: '14px', 
                                    height: '14px',
                                    filter: 'none'
                                  }} 
                                />
                              </div>
                            </li>
                          );
                        })}
                      </ul>
                    </Paper>
                  </Popover>
                </div>
              )}
          </div>
        </div>
      </div>
      
      <FloatingAlert
        open={showJobCompletionAlert}
        completedJobs={completedJobs}
        onClose={handleJobCompletionAlertClose}
      />
    </>
  );
};

export default ProcessNotification;
